<template>
  <div>
    <buildings-of-building-complex
      :refresh-buildings="refreshBuildings"
      :buildings="buildingComplex.buildings"
      :id-building-complex="buildingComplex.id"
      :selected-building="selectedBuilding"
      @addSelectedBuildings="addSelectedBuildings"
    ></buildings-of-building-complex>

    <apartment
      :apartments="shownApartments"
      :selected-buildings="selectedBuildings"
      @refreshBuildings="refreshBuildingss"
      @addSelectedApartments="addSelectedApartments"
    ></apartment>

    <inhabitant
      :inhabitants="shownInhabitants"
      @refreshBuildings="refreshBuildingss"
    ></inhabitant>
  </div>
</template>

<script>
import BuildingsOfBuildingComplex from '@/modules/buildings/components/BuildingsOfBuildingComplex';
import Apartment from '@/components/apartments/Apartment';
import Inhabitant from '@/components/inhabitants/Inhabitant';

export default {
  name: 'BuildingsApartmentsInhabitantsLists',

  components: {
    BuildingsOfBuildingComplex,
    Apartment,
    Inhabitant
  },

  props: {
    buildingComplex: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    shownApartments: [],
    shownInhabitants: [],
    selectedBuildings: [],
    selectedApartments: [],
    selectedBuilding: null,
    refreshBuildings: false
  }),

  watch: {
    selectedBuildings: function(selectedBuildings) {
      this.shownApartments.length = 0;
      if (selectedBuildings.length !== 0)
        selectedBuildings.forEach(el => {
          if(!el.apartments) {
            return;
          }
          el.apartments.forEach(apartment => {
            apartment.inhabitants_count = apartment.inhabitants.length;
            apartment.status =
              apartment.inhabitants_count > 0 ? 'OCCUPIED' : 'FREE';
          });

          this.shownApartments.push(...el.apartments);
        });
      else if (selectedBuildings.length == 0) {
        this.shownApartments = [];
        this.shownInhabitants = [];
      }
    },
    selectedApartments: function(selectedApartments) {
      this.shownInhabitants.length = 0;
      if (selectedApartments.length !== 0)
        selectedApartments.forEach(el =>
          this.shownInhabitants.push(...el.inhabitants)
        );
      else if (selectedApartments.length === 0) this.shownInhabitants = [];
    }
  },

  created() {
    this.selectedBuilding = this.$route.params.selectedBuilding;
  },

  methods: {
    refreshBuildingss() {
      this.refreshBuildings = !this.refreshBuildings;
    },
    addSelectedBuildings(selectedBuildings) {
      this.selectedBuildings = selectedBuildings;
    },
    addSelectedApartments(selectedApartments) {
      this.selectedApartments = selectedApartments;
    }
  }
};
</script>

<style scoped></style>
